import React, { useState } from 'react';
import config from '../config';

import FeatureContext, { IFeatureContext } from '../context/FeatureContext';

const FeatureProvider: React.FC = ({ children }) => {
  const [featureFlags, setFeatureFlags] = useState<IFeatureContext[]>(
    config.features
  );

  const getFeatureState = (featureSearchName: string) => {
    const featureEnabled = featureFlags.filter(
      (item) => item.featureName === featureSearchName
    );
    if (!featureEnabled || featureEnabled.length <= 0) return null;
    return featureEnabled[0].enabled;
  };

  return (
    <FeatureContext.Provider value={featureFlags}>
      {children}
    </FeatureContext.Provider>
  );
};

export { FeatureProvider, FeatureContext };
